// src/components/Footer.jsx
import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-gray-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-center gap-6">
        {/* Left logo */}
        <img src="/logo.png" alt="Logo" className="h-8 w-auto object-contain" />

        {/* Center copyright text */}
        <span className="text-xs sm:text-sm text-gray-500 text-center">
          © {year} EKOPACK INC. · All rights reserved
        </span>

        {/* Right logo */}
        <img
          src="/ekopack-logo.png"
          alt="Ekopack Logo"
          className="h-7 object-contain"
        />
      </div>
    </footer>
  );
};

export default Footer;
